module.exports = __webpack_public_path__ + "img/t2-frame.ddfb1955.png";